import {
  PharmacyLabRadiology,
  PharmacyLabRadiologyControllerApi,
} from "@/services";
import { getConfigObject, useMutationWithLoading } from "@/utils/utils";

interface Params {
  preferenceUuid: string;
  pharmacyLabRadiology: PharmacyLabRadiology;
  xTENANTID?: string;
}

export const useUpdatePharmacyLabRadiology = () =>
  useMutationWithLoading(async (params: Params) =>
    new PharmacyLabRadiologyControllerApi(
      getConfigObject()
    ).updatePharmacyLabRadiology(
      params.preferenceUuid,
      params.pharmacyLabRadiology,
      params.xTENANTID
    )
  );
